(function() {
  var THRESHOLD = 100000;
  var observer = null;
  var fetching = false;
  var lastTotal = -1;

  function formatARS(n) { return '$' + Math.ceil(n).toLocaleString('es-AR'); }

  function updateBar(bar, totalARS) {
    if (!bar) return;
    var fill      = bar.querySelector('.gu-transfer-bar__fill');
    var falta     = bar.querySelector('.gu-transfer-bar__falta');
    var pendingEl = bar.querySelector('.gu-transfer-bar__pending');
    var activeEl  = bar.querySelector('.gu-transfer-bar__active');
    var pct = Math.min(100, (totalARS / THRESHOLD) * 100);
    if (fill) fill.style.width = pct + '%';
    if (totalARS >= THRESHOLD) {
      bar.classList.add('is-active');
      if (pendingEl) pendingEl.style.display = 'none';
      if (activeEl)  activeEl.style.display = '';
    } else {
      bar.classList.remove('is-active');
      if (pendingEl) pendingEl.style.display = '';
      if (activeEl)  activeEl.style.display = 'none';
      if (falta) falta.textContent = formatARS(THRESHOLD - totalARS);
    }
  }

  function updateShipBar(bar, totalCents) {
    var threshold = parseInt(bar.dataset.shipThreshold) || 0;
    if (!threshold) return;
    var fill = bar.querySelector('.gu-cart__shipping-fill');
    var msg  = bar.querySelector('.gu-cart__shipping-msg');
    var pct  = Math.min(100, Math.max(0, (totalCents / threshold) * 100));
    if (fill) fill.style.width = pct + '%';
    var rem = threshold - totalCents;
    if (rem > 0) {
      bar.classList.remove('gu-cart__shipping-bar--unlocked');
      if (msg) msg.textContent = 'Te faltan ' + formatARS(rem / 100) + ' para obtener envío gratis';
    } else {
      bar.classList.add('gu-cart__shipping-bar--unlocked');
      if (msg) msg.textContent = 'Ya tenés envío gratis';
    }
  }

  function applyTotal(totalCents) {
    if (observer) observer.disconnect();
    var bars = document.querySelectorAll('.gu-transfer-bar');
    for (var i = 0; i < bars.length; i++) {
      updateBar(bars[i], totalCents / 100);
    }
    var shipBars = document.querySelectorAll('.gu-cart__shipping-bar[data-ship-threshold]');
    for (var j = 0; j < shipBars.length; j++) {
      updateShipBar(shipBars[j], totalCents);
    }
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function fetchAndUpdate() {
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(c) {
        if (c.total_price !== lastTotal) {
          lastTotal = c.total_price;
          applyTotal(c.total_price);
        }
      })
      .catch(function() {})
      .then(function() { fetching = false; });
  }

  var t;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(fetchAndUpdate, 200);
  }

  function init() {
    var b = document.querySelector('.gu-transfer-bar[data-total]');
    if (b && b.dataset.total) applyTotal(parseFloat(b.dataset.total) * 100);
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    fetchAndUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart-drawer:open', schedule);
})();